export enum AssistanceRequestStatus {
  EOB_PENDING = 'eob_pending',
  EOB_IN_REVIEW = 'eob_in_review',
  EOB_PAID = 'eob_paid',
}
